import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ChangeEvent, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { setFilters, setGlobalFilterValue, setToEdit } from "../../store/slices/positiveItemSlice";
import { selectPositiveItem } from "../../store/selectors/positiveItemSelectors";
import { selectInspectionId, selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";
import { createDefaultPositiveItem } from "../../utils/positiveItemTableHelper";
import { PositiveItemsDeleteButton } from "./PositiveItemsDeleteButton";

export const PositiveItemTableHeader = () => {    
    const dispatch = useAppDispatch();

    const { filters, globalFilterValue } = useAppSelector(selectPositiveItem)
    const inspectionId = useAppSelector(selectInspectionId);
    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const onAdd = useCallback(() => {
        if (inspectionId) {
            dispatch(setToEdit(createDefaultPositiveItem(inspectionId)));
        }
    }, [inspectionId]);


    const onGlobalFilterChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const updatedFilters = {
            ...filters,
            global: {
                ...filters.global,
                value: event.target.value
            }
        };

        dispatch(setFilters(updatedFilters));
        dispatch(setGlobalFilterValue(value));
    }, [filters]);

    return (
        <div className="flex justify-content-between">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
            </span>
            <div>
                <Button icon="pi pi-plus" className="ml-3" onClick={onAdd} disabled={inspectionDisabled} />
                <PositiveItemsDeleteButton />
            </div>
        </div>
    );
}